import { defineMessages } from 'react-intl';

import { ActionSchema } from './action';

const messages = defineMessages({
  AddItem: {
    id: 'label_add_item',
    defaultMessage: 'Add item',
  },
  Actions: {
    id: 'label_actions',
    defaultMessage: 'Actions',
  },
  Divider: {
    id: 'label_divider',
    defaultMessage: 'Divider',
  },
  Discreet: {
    id: 'label_discreet',
    defaultMessage: 'Discreet',
  },
  ShowDivider: {
    id: 'label_show',
    defaultMessage: 'Show divider',
  },
  Title: {
    id: 'label_title',
    defaultMessage: 'Title',
  },
});

export const DividerSchema = (props) => ({
  addMessage: props.intl.formatMessage(messages.AddItem),
  conditions: {
    actions: {
      show: true,
    },
    discreet: {
      show: true,
    },
    title: {
      show: true,
    },
  },
  fieldsets: [
    {
      fields: ['show', 'title', 'discreet', 'actions'],
      id: 'default',
      title: '',
    },
  ],
  properties: {
    actions: {
      title: props.intl.formatMessage(messages.Actions),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: ActionSchema(props),
          },
        },
      },
    },
    discreet: {
      title: props.intl.formatMessage(messages.Discreet),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    show: {
      title: props.intl.formatMessage(messages.ShowDivider),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    title: {
      title: props.intl.formatMessage(messages.Title),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
  },
  required: [],
  title: props.intl.formatMessage(messages.Divider),
});
